const messageScope = {
    INFO:1,
    HEALTH: 2
}

export default messageScope;